<template>
  <div v-show="agentSetup.currentPage === 7" class="bg-base-100 border border-base-300 rounded-box p-6 shadow-sm" style="min-height: 40vh;">
    <div class="flex justify-between" id="tabTitle">
      <h1 class="text-2xl mb-0" :style="agentSetup.isRtl === true ? { direction: 'rtl', textAlign: 'right' } : { direction: 'ltr', textAlign: 'left' }">{{ agentSetup.t('aiChatAgentSetup.rules.title', 'Agent Rules') }}</h1>
    </div>
    <div class="mt-4">
      <div class="mb-4">
        <RuleLibraryPanel :is-rtl="agentSetup.isRtl" :existing-rules="agentSetup.rules" :selected-language="agentSetup.agentLanguage" :agent-description="agentSetup.agentDescription" @add-rule="agentSetup.addRuleFromLibrary" />
      </div>
      <div class="flex space-x-2 mb-4">
        <textarea v-model="agentSetup.newRule" maxlength="3500" rows="1" class="textarea textarea-bordered flex-1 resize-none overflow-hidden" :placeholder="agentSetup.t('aiChatAgentSetup.rules.newRulePlaceholder','Enter a new rule')" :style="agentSetup.getDirStyle('newRule')" @keydown="agentSetup.handleDirKeydown($event, 'newRule')" @input="($event.target.style.height='auto',$event.target.style.height=$event.target.scrollHeight+'px')"></textarea>
        <div class="text-xs text-right pr-1 mt-1 self-center text-gray-500">{{ agentSetup.newRule.length }}/3500</div>
        <button @click="agentSetup.addRule" class="btn">{{ agentSetup.t('aiChatAgentSetup.rules.addRuleButton','Add Rule') }}</button>
      </div>
      <div class="space-y-2" style="min-height: 300px;">
        <div v-for="(rule, index) in agentSetup.rules" :key="index" class="flex items-center space-x-2 p-2 bg-base-200 rounded-lg">
          <span v-if="agentSetup.editingRuleIndex !== index" class="flex-1" @click="agentSetup.startEditingRule(index)">{{ rule }}</span>
          <textarea v-else :ref="setEditingRuleInput" v-model="agentSetup.rules[index]" maxlength="3500" rows="1" class="textarea textarea-bordered flex-1 resize-none overflow-hidden" :style="agentSetup.getDirStyle('editingRule')" @keydown="agentSetup.handleDirKeydown($event, 'editingRule')" @input="($event.target.style.height='auto',$event.target.style.height=$event.target.scrollHeight+'px')" @blur="agentSetup.stopEditingRule" @keyup.enter="agentSetup.stopEditingRule"></textarea>
          <button @click="agentSetup.removeRule(index)" class="btn btn-sm btn-error">{{ agentSetup.t('aiChatAgentSetup.rules.removeRuleButton','Remove') }}</button>
        </div>
      </div>
    </div>
    <div class="flex justify-between mt-4" style="position: relative;">
      <button @click="agentSetup.goNextStep(7, -1)" class="btn">
        <span v-if="agentSetup.isNavigating === 6" class="loading loading-spinner loading-sm mr-2"></span>
        {{ agentSetup.t('aiChatAgentSetup.buttons.previousStep', 'Previous Step') }}
      </button>
      <div class="flex items-center space-x-2" :class="agentSetup.isRtl === true ? 'space-x-reverse' : ''">
        <button v-if="agentSetup.isEditMode === true && agentSetup.uploadedFiles.length === 0" @click="agentSetup.saveAgentWithoutRedirect" class="btn btn-neutral">
          <span v-if="agentSetup.isSaving === true && agentSetup.isSavingAndRedirecting === false" class="loading loading-spinner loading-sm mr-2"></span>
          {{ agentSetup.t('aiChatAgentSetup.buttons.save', 'Save') }}
        </button>
        <button v-if="agentSetup.isEditMode === true" @click="agentSetup.createAgent(true)" class="btn">
          <span v-if="agentSetup.isSaving === true && agentSetup.isSavingAndRedirecting === true" class="loading loading-spinner loading-sm mr-2"></span>
          {{ agentSetup.t('aiChatAgentSetup.buttons.saveAndClose', 'Save & Close') }}
        </button>
        <button @click="agentSetup.goNextStep(7, 1)" class="btn">
          <span v-if="agentSetup.isNavigating === 8" class="loading loading-spinner loading-sm mr-2"></span>
          {{ agentSetup.t('aiChatAgentSetup.buttons.nextStep', 'Next Step') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import RuleLibraryPanel from '@/components/RuleLibraryPanel.vue';
import { useAgentSetupContext } from '@/components/AgentSetupContext.js';

const agentSetup = useAgentSetupContext();

function setEditingRuleInput(value) {
  agentSetup.setEditingRuleInput(value);
}
</script>
